import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { USER_FILTER_APELLIDO, USER_FILTER_LEGAJO, USER_FILTER_NIVEL, USER_FILTER_NOMBRE, USER_FILTER_OFIJU, USER_FILTER_PERFIL, USER_FILTER_UNIDAD } from '../../../constants/userFilters';
import { ICON_REFRESH, ICON_SEARCH } from '../../extras/icons';
import profiles from '../../../data/profiles';
import { useSelector } from 'react-redux';
import { ErrorMessage, WaitingMessage } from '../../extras/toastMessages';
import { MSG_ERROR_SELECT_FILTER, MSG_ERROR_SERVER, MSG_LOADING_INFORMATION } from '../../../constants/messages';
//Axios
import clienteAxios from '../../../config/axios';
import Swal from 'sweetalert2';
//Función principal
const UserSearch = props => {
    //Tomo los props
    const { setSearch } = props;
    //Inicializo el state local
    const [ filter, setFilter ] = useState('');
    const [ filterValue, setFilterValue ] = useState('');
    const [ selectData, setSelectData ] = useState(null);
    //Manejo los cambios
    const handleFilterChange = e => {
        //Seteo los datos
        setFilter(e.target.value);
        //Reinicio selección
        setFilterValue('');
        //Cargo los parámetros
        loadParameters(e.target.value);
        //Me fijo si es vacío para reiniciar la búsqueda
        if(e.target.value === ''){
            setSearch('');
        }
    }
    //Manejo el cambio de valores
    const handleChange = e => {
        setFilterValue(e.target.value);
    }
    //Carga los parámetros
    const loadParameters = value => {
        //Me fijo que tengo que cargar
        switch (value) {
            case USER_FILTER_NIVEL:
                loadLevels();
                break;
            case USER_FILTER_PERFIL:
                loadProfiles();
                break;
            case USER_FILTER_UNIDAD:
                loadUnits();
                break;
            case USER_FILTER_OFIJU:
                loadOfijus();
                break;
            default:
                setSelectData(null);
                break;
        }
    }
    //Funcíon que hace la consulta
    const handleQuery = async (method, params) => {
        //Cargo la espera
        WaitingMessage(MSG_LOADING_INFORMATION);
        //Consulta
        try{
            //Hago la consulta
            const response = await clienteAxios.get(`/${method}`, { params });
            //Obtengo los datos
            const res = response.data;
            //Llamo al dispatch
            setSelectData(res.content);
            //Oculto la espera
            Swal.close();
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Oculto la espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
    //Cargo los niveles
    const loadLevels = () => {
        //Seteo los parametros
        const params = {
            sort: 'id:asc'
        }
        //Ejecuto consulta
        handleQuery('nivel', params);
    }
    //Cargo los perfiles
    const loadProfiles = () => {
        //Seteo los datos
        setSelectData(profiles);
    }
    //Cargo las unidades
    const loadUnits = () => {
        //Seteo los parametros
        const params = {
            search: 'activo:1',
            sort: 'descripcion:asc'
        }
        //Ejecuto consulta
        handleQuery('unidad', params);
    }
    //Cargo las ofijus
    const loadOfijus = () => {
        //Seteo los parametros
        const params = {
            search: 'activo:1',
            sort: 'nombre:asc'
        }
        //Ejecuto consulta
        handleQuery('ofiju', params);
    }
    //Manejo el submit
    const handleSubmit = e => {
        e.preventDefault();
        //Verifico el filtro a usar
        if(filter !== ''){
            //Sufijo
            let suffix = '';
            //Me fijo si hay q agregar
            if(filter === USER_FILTER_NIVEL || filter === USER_FILTER_PERFIL || filter === USER_FILTER_UNIDAD || filter === USER_FILTER_OFIJU){
                //Seteo
                suffix = '.id';
            }
            //Inicializo
            let search = `${filter}${suffix}:${filterValue}`;
            //Seteo la búsqueda
            setSearch(search);
        }else{
            //Error
            ErrorMessage(MSG_ERROR_SELECT_FILTER);
        }
    }
    //Manejo el limpiar
    const handleClear = e => {
        e.preventDefault();
        setFilter('');
        setFilterValue('');
        setSearch('');
    }
    //Renderizo
    return (
        <div className="row">
            <form onSubmit={handleSubmit} className="col">
                <div className="row">
                    <div className="col-md-2">
                        <select name="filter" className="form-control" onChange={handleFilterChange} value={filter}>
                            <option value="">Seleccione Filtro</option>
                            <option value={ USER_FILTER_LEGAJO }>{ USER_FILTER_LEGAJO.toUpperCase() }</option>
                            <option value={ USER_FILTER_APELLIDO }>{ USER_FILTER_APELLIDO.toUpperCase() }</option>
                            <option value={ USER_FILTER_NOMBRE }>{ USER_FILTER_NOMBRE.toUpperCase() }</option>
                            <option value={ USER_FILTER_NIVEL }>{ USER_FILTER_NIVEL.toUpperCase() }</option>
                            <option value={ USER_FILTER_PERFIL }>{ USER_FILTER_PERFIL.toUpperCase() }</option>
                            <option value={ USER_FILTER_UNIDAD }>{ USER_FILTER_UNIDAD.toUpperCase() }</option>
                            <option value={ USER_FILTER_OFIJU }>{ USER_FILTER_OFIJU.toUpperCase() }</option>
                        </select>
                    </div>
                    {
                        filter === USER_FILTER_LEGAJO || filter === USER_FILTER_APELLIDO || filter === USER_FILTER_NOMBRE ? (
                            <div className="col-md-2">
                                <input type="text"
                                    name="textFilter"
                                    className="form-control"
                                    placeholder={`Ingrese ${filter.charAt(0).toUpperCase()}${filter.slice(1)}`}
                                    //value={filterValue}
                                    onChange={handleChange}
                                />
                            </div>
                        ) : null
                    }
                    
                    {
                        filter === USER_FILTER_NIVEL || filter === USER_FILTER_PERFIL || filter === USER_FILTER_UNIDAD || filter === USER_FILTER_OFIJU ? (
                            <div className="col-md-4">
                                <select name="selectFilter" className="form-control" onChange={handleChange}>
                                    <option value="">Seleccione {`${filter.charAt(0).toUpperCase()}${filter.slice(1)}`}...</option>
                                    {
                                        selectData ? (
                                            selectData.map(item => (
                                                <option value={item.id} key={`ussf${item.id}`}>
                                                    { item.descripcion ? item.descripcion : item.nombre }
                                                </option>
                                            ))
                                        ) : null
                                    }
                                </select>
                            </div>
                        ) : null
                    }
                    
                    <div className="col-md-1">
                        <Button
                            variant="primary"
                            type="submit"
                            block
                        >
                            <ICON_SEARCH />
                        </Button>
                    </div>
                    <div className="col-md-1">
                        <Button
                            variant="warning"
                            type="button"
                            onClick={handleClear}
                            block
                        >
                            <ICON_REFRESH />
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default UserSearch;